import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';

import { SellerBankProvider } from "../../contexts/sellerContext/SellerBankContext";
import { SellerProvider } from "../../contexts/sellerContext/SellerContext";
import { SellerDetailProvider } from "../../contexts/sellerContext/SellerDetailContext";
import { SellerRequestProvider } from "../../contexts/sellerContext/SellerRequestsContext";
import SellerTransectionList from './views/SellerTransectionList';

const SellerFragment = Loadable(lazy(() => import('./views/SellerFragment')));
const SellerBankFragment = Loadable(lazy(() => import('./views/SellerBankFragment')));
const SellerDetailFragment = Loadable(lazy(() => import('./views/SellerDetailFragment')));
const SellerRatingDetails = Loadable(lazy(() => import('./views/SellerRatingDetails')));
const SellerRequestFragment = Loadable(lazy(() => import('./views/SellerRequestFragment')));
const EditSellerFragment = Loadable(lazy(() => import('./views/EditSellerFragment')));

const sellerRoutes = [
    { path: '/sellers', element: <SellerProvider><SellerFragment /></SellerProvider> },
    { path: '/seller_edit/:id', element: <SellerDetailProvider><EditSellerFragment /></SellerDetailProvider> },
    { path: '/seller_detail/:id', element: <SellerDetailProvider><SellerDetailFragment /></SellerDetailProvider> },
    { path: '/seller-rating-details/:id', element: <SellerDetailProvider><SellerRatingDetails /></SellerDetailProvider> },
    { path: '/seller_banks', element: <SellerBankProvider><SellerBankFragment /></SellerBankProvider> },
    { path: '/seller_requests', element: <SellerRequestProvider><SellerRequestFragment /></SellerRequestProvider> },
    { path: '/seller_transection_details/:id', element: 
        <SellerRequestProvider>
            <SellerTransectionList />
        </SellerRequestProvider> },
];

export default sellerRoutes;
